import { useMemo, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconButton, HStack } from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import { MdEdit } from 'react-icons/md';

import Button from 'components/v4/Button';
import AGGridMain from 'components/tables/AGGrid/AGGridMain';
import { useGetRules } from '../queries';

const RulesTable = ({ dialPlanId }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const gridRef = useRef();

    const { data: rules, isLoading, refetch } = useGetRules(dialPlanId);

    const columnDefs = useMemo(
        () => [
            {
                headerName: 'Name',
                field: 'name',
            },
            {
                headerName: 'Priority',
                field: 'priority',
                sort: 'asc',
            },
            {
                headerName: 'Pattern',
                field: 'pattern',
            },
            {
                headerName: 'Translation',
                field: 'translation',
            },
            {
                headerName: 'Action',
                field: 'action',
                maxWidth: 100,
                cellRenderer: (params) => (
                    <IconButton
                        aria-label="Edit rule"
                        icon={<MdEdit />}
                        variant="ghost"
                        color="inherit"
                        size="sm"
                        onClick={() =>
                            navigate(
                                `/dial-plans/${dialPlanId}/rules/${params.data.id}${location.search}`,
                            )
                        }
                    />
                ),
                filter: false,
                sortable: false,
            },
        ],
        [navigate, dialPlanId, location.search],
    );

    const tableDataWithColumns = useMemo(
        () => ({
            columns: columnDefs,
            data: rules || [],
        }),
        [rules, columnDefs],
    );

    const handleAdd = () => {
        navigate(`/dial-plans/${dialPlanId}/rules/add${location.search}`);
    };

    return (
        <AGGridMain
            gridRef={gridRef}
            tableData={tableDataWithColumns}
            titleName="Rules"
            isLoading={isLoading}
            extraComponents={
                <HStack pl={5} spacing={2}>
                    <Button
                        leftIcon={<AddIcon />}
                        size="sm"
                        onClick={handleAdd}>
                        Rules
                    </Button>
                </HStack>
            }
            refetch={refetch}
            useFixedHeight={false}
            domLayout="autoHeight"
            customHeight="auto"
        />
    );
};

export default RulesTable;
